import React from "react";

/**
 * Primo brand mark — image-only logotype (per client request).
 * No product wordmark or tagline is appended beside the logo.
 */
export default function PrimoLogo({ className = "" }) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/brand/primo-logo.png"
        alt="Primo"
        className="h-8 w-auto shrink-0 select-none"
        draggable={false}
      />
    </div>
  );
}
